/**
 * 工具类
 */
import CryptoJS from 'crypto-js'
// 默认的 KEY 与 iv 如果没有给
// const KEY = CryptoJS.enc.Utf8.parse("1234567890123456");
// const IV = CryptoJS.enc.Utf8.parse('1234567890123456');
// /**
//  * AES加密 ：字符串 key iv  返回base64 
//  */
// export function Encrypt(word, keyStr, ivStr) {
//   let key = KEY
//   let iv = IV
//   if (keyStr) {
//     key = CryptoJS.enc.Utf8.parse(keyStr);
//     iv = CryptoJS.enc.Utf8.parse(ivStr);
//   }
 
//   let srcs = CryptoJS.enc.Utf8.parse(word);
//   var encrypted = CryptoJS.AES.encrypt(srcs, key, {
//     iv: iv,
//     mode: CryptoJS.mode.CBC,
//     padding: CryptoJS.pad.ZeroPadding
//   });
//  // console.log("-=-=-=-", encrypted.ciphertext)
//   return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
 
// }
// /**
//  * AES 解密 ：字符串 key iv  返回base64 
//  *
//  */
// export function Decrypt(word, keyStr, ivStr) {
//   let key  = KEY
//   let iv = IV
 
//   if (keyStr) {
//     key = CryptoJS.enc.Utf8.parse(keyStr);
//     iv = CryptoJS.enc.Utf8.parse(ivStr);
//   }
 
//   let base64 = CryptoJS.enc.Base64.parse(word);
//   let src = CryptoJS.enc.Base64.stringify(base64);
 
//   var decrypt = CryptoJS.AES.decrypt(src, key, {
//     iv: iv,
//     mode: CryptoJS.mode.CBC,
//     padding: CryptoJS.pad.ZeroPadding
//   });
 
//   var decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
//   return decryptedStr.toString();
// }


var iv = CryptoJS.enc.Utf8.parse('1234567890123456');
var cryptoObj = {
    /* 加密 */
    encryptFunc: (word, keyStr) => {
        var key = CryptoJS.enc.Utf8.parse(keyStr);
        var encryptedObj = CryptoJS.AES.encrypt(word,key,{iv:iv,mode:CryptoJS.mode.CBC,padding:CryptoJS.pad.ZeroPadding});
        return encryptedObj.toString();
    },
    /* 解密 */
    decryptFunc: (word, keyStr) => {
        var key = CryptoJS.enc.Utf8.parse(keyStr);
        return CryptoJS.AES.decrypt(word,key,{iv:iv,padding:CryptoJS.pad.ZeroPadding});
    },
}
export default cryptoObj;





// WEBPACK FOOTER //
// ./src/jiami/index.js